var _style, _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "height_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".height_svg__st1{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 19.7c-4.2 0-7.9 2.5-9.6 6.1 1.5-.8 3.2-1.2 4.9-1.2 5.9 0 10.6 4.8 10.6 10.6 0 1.6-.4 3.2-1 4.6 3.4-1.8 5.7-5.3 5.7-9.4 0-5.9-4.7-10.7-10.6-10.7z",
    fill: "var(--color-icon-primary)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "height_svg__st1",
    cx: 90.5,
    cy: 29.7,
    r: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--color-icon-primary)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M18.5 134.5v-121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "height_svg__st1",
    d: "M25.5 132.9h9.1M25.5 124.6h5M34.6 116.2h-9.1M25.5 107.9h5M34.6 99.5h-9.1M25.5 91.1h5M34.6 82.8h-9.1M25.5 74.4h5M34.6 66.1h-9.1M25.5 57.4h5M34.6 49.1h-9.1M25.5 40.4h5M34.6 32.1h-9.1M25.5 23.4h5M34.6 15.1h-9.1M103.6 48.4l6.6 5.9 18.9 17.5c2.2 2 2.4 5.3.4 7.5s-5.3 2.4-7.5.4l-16.6-14.6V80c0 7.8 1 15.5 3.1 23l6.2 22.7c.9 3.5-.9 7.3-4.4 8.3-3.6 1.1-7.3-1-8.3-4.6L92.7 95c-.2-.6-.4-1.1-.8-1.5-.6-.6-1.4-.9-2.2-.9-1.5 0-2.9.9-3.3 2.3l-9.3 34.4c-1 3.6-4.7 5.7-8.3 4.6-3.5-1.1-5.3-4.8-4.4-8.3l6.2-22.6c2-7.5 3.1-15.2 3.1-23V65L57.1 79.7c-2.2 2-5.5 1.8-7.5-.4s-1.8-5.5.4-7.5l18.9-17.5 6.6-5.9"
  })));
}
export default SvgHeight;